import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useStateValue } from '../../../Contexto/store';
import DiccionarioEtiquetas from '../../../Configuracion/Idiomas/Etiquetas_Diccionario';
import { obtenerListaCompaniasUsuario } from '../../../Actions/Usuarios/UsuarioAction';
import { AutorizacionUsuario } from '../../../Actions/Usuarios/AutorizacionAction';
import Enumerable from 'linq';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Business from '@mui/icons-material/Business';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { obtenerConfiguracionHoraFecha, obtenerImagenReducida } from '../../../Actions/Companias/CompaniaAction';

import withStyles from '@mui/styles/withStyles';
import { styleButtonBar } from '../../Tool/Style';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
));

const Companias = () => {

    //Estilo de los iconos de la barra
    const classIcon = styleButtonBar();

    const [{ etiquetasIdioma, sesionUsuario, compania }, dispatch] = useStateValue();

    const [anchorEl, setAnchorEl] = useState(null);

    const Cerrar = () => {
        setAnchorEl(null);
    };

    const [listaCompanies, setListaCompanies] = useState([{
        comCompanyId: '',
        comName: '',
        uscDefectCompany: false
    }]);

    const seleccionaCompaniaCerrar = async (event) => {
        event.preventDefault();
        const { companyid } = event.currentTarget.dataset;

        const usuario = {
            userId: sesionUsuario.usuario.userId,
            nombreCompleto: sesionUsuario.usuario.nombreCompleto,
            email: sesionUsuario.usuario.email,
            username: sesionUsuario.usuario.username,
            imagenPerfil: sesionUsuario.usuario.imagenPerfil,
            defaultLanguage: sesionUsuario.usuario.defaultLanguage,
            companyId: companyid,
            customerId: sesionUsuario.usuario.customerId
        }

        dispatch({
            type: "INICIAR_SESION",
            sesion: usuario,
            autenticado: sesionUsuario.autenticado,
            tipoLogueo: sesionUsuario.tipoLogueo
        });

        setAnchorEl(null);

        await obtieneLogoCompaniaReducida(companyid);

        AutorizacionUsuario(companyid, "11111111-1111-1111-1111-111111111111", sesionUsuario.usuario.userId, etiquetasIdioma.CodigoIdioma, dispatch);

        const responseFormatos = await obtenerConfiguracionHoraFecha(companyid);        

        if (responseFormatos.status === 200) //si la respuesta fue existosa
        {
            window.localStorage.setItem("formatFecha_ClassLimitless", responseFormatos.data.datesFormat);
            window.localStorage.setItem("formatHora_ClassLimitless", responseFormatos.data.hoursFormat);
        }

        window.localStorage.setItem("selected_company", companyid);
    };

    const obtieneLogoCompaniaReducida = async (companiaId) => {

        const peticionImagen = {
            CompanyId: companiaId
        };
        const responseImagen = await obtenerImagenReducida(peticionImagen);

        if (responseImagen.status === 200) //si la respuesta fue existosa
        {
            let imgCompania = responseImagen.data?.contentBase64;
            if (imgCompania === undefined || imgCompania === null)
                imgCompania = "";
            window.localStorage.setItem("logoCompania_ClassLimitless", imgCompania);

        } else {
            window.localStorage.setItem("logoCompania_ClassLimitless", "");
        }
    };

    const ClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
        obtenerListaCompaniasUsuario(sesionUsuario.usuario.userId).then(responce => {
            const array = Enumerable.from(responce?.data).toArray();
            setListaCompanies(array);
        });
    };

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    return (
        <React.Fragment>
            <Button color="inherit" className={classIcon.Button} onClick={ClickMenu} aria-controls="Company-menu" aria-haspopup="true" >
                <IconButton
                    className={classIcon.IconButton}
                    style={{ backgroundColor: compania.CfgNavIconBG }}
                    size="large">
                    <Business className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
                </IconButton>
                <KeyboardArrowDownIcon className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
            </Button>
            <StyledMenu
                id="Company-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={Cerrar}
            >
                {
                    listaCompanies.map((company) => (<MenuItem key={company.comCompanyId} data-CompanyId={company.comCompanyId} onClick={seleccionaCompaniaCerrar}>{company.comName}</MenuItem>))
                }
            </StyledMenu>
        </React.Fragment>
    );
}

export default Companias;